export { default as AppstoreOutlined } from './AppstoreOutlined.svg?react';
export { default as AuditOutlined } from './AuditOutlined.svg?react';
export { default as BankOutlined } from './BankOutlined.svg?react';
export { default as BarChartOutlined } from './BarChartOutlined.svg?react';
export { default as BranchesOutlined } from './BranchesOutlined.svg?react';
export { default as CalendarOutlined } from './CalendarOutlined.svg?react';
export { default as CameraOutlined } from './CameraOutlined.svg?react';
export { default as CarOutlined } from './CarOutlined.svg?react';
export { default as CheckCircleOutlined } from './CheckCircleOutlined.svg?react';
export { default as CheckOutlined } from './CheckOutlined.svg?react';
export { default as ClockCircleOutlined } from './ClockCircleOutlined.svg?react';
export { default as CloseOutlined } from './CloseOutlined.svg?react';
export { default as CreditCardOutlined } from './CreditCardOutlined.svg?react';
export { default as DeleteOutlined } from './DeleteOutlined.svg?react';
export { default as DisconnectOutlined } from './DisconnectOutlined.svg?react';
export { default as DoubleLeftOutlined } from './DoubleLeftOutlined.svg?react';
export { default as DownOutlined } from './DownOutlined.svg?react';
export { default as DownloadOutlined } from './DownloadOutlined.svg?react';
export { default as EditOutlined } from './EditOutlined.svg?react';
export { default as EyeInvisibleOutlined } from './EyeInvisibleOutlined.svg?react';
export { default as EyeOutlined } from './EyeOutlined.svg?react';
export { default as FilePdfOutlined } from './FilePdfOutlined.svg?react';
export { default as FileSearchOutlined } from './FileSearchOutlined.svg?react';
export { default as FileTextOutlined } from './FileTextOutlined.svg?react';
export { default as FilterOutlined } from './FilterOutlined.svg?react';
export { default as GlobalOutlined } from './GlobalOutlined.svg?react';
export { default as HomeOutlined } from './HomeOutlined.svg?react';
export { default as IdcardOutlined } from './IdcardOutlined.svg?react';
export { default as ImportOutlined } from './ImportOutlined.svg?react';
export { default as InboxOutlined } from './InboxOutlined.svg?react';
export { default as InfoCircleOutlined } from './InfoCircleOutlined.svg?react';
export { default as KeyOutlined } from './KeyOutlined.svg?react';
export { default as LeftOutlined } from './LeftOutlined.svg?react';
export { default as LoadingOutlined } from './LoadingOutlined.svg?react';
export { default as LockOutlined } from './LockOutlined.svg?react';
export { default as LogoutOutlined } from './LogoutOutlined.svg?react';
export { default as MailOutlined } from './MailOutlined.svg?react';
export { default as MenuFoldOutlined } from './MenuFoldOutlined.svg?react';
export { default as MenuOutlined } from './MenuOutlined.svg?react';
export { default as MenuUnfoldOutlined } from './MenuUnfoldOutlined.svg?react';
export { default as MessageOutlined } from './MessageOutlined.svg?react';
export { default as MinusCircleOutlined } from './MinusCircleOutlined.svg?react';
export { default as MoonOutlined } from './MoonOutlined.svg?react';
export { default as MoreOutlined } from './MoreOutlined.svg?react';
export { default as PhoneOutlined } from './PhoneOutlined.svg?react';
export { default as PictureOutlined } from './PictureOutlined.svg?react';
export { default as PlusOutlined } from './PlusOutlined.svg?react';
export { default as ProjectOutlined } from './ProjectOutlined.svg?react';
export { default as QuestionCircleOutlined } from './QuestionCircleOutlined.svg?react';
export { default as RightOutlined } from './RightOutlined.svg?react';
export { default as SaveOutlined } from './SaveOutlined.svg?react';
export { default as SearchOutlined } from './SearchOutlined.svg?react';
export { default as SettingsOutlined } from './SettingsOutlined.svg?react';
export { default as ShopOutlined } from './ShopOutlined.svg?react';
export { default as SolutionOutlined } from './SolutionOutlined.svg?react';
export { default as StopOutlined } from './StopOutlined.svg?react';
export { default as SunOutlined } from './SunOutlined.svg?react';
export { default as SwapOutlined } from './SwapOutlined.svg?react';
export { default as TeamOutlined } from './TeamOutlined.svg?react';
export { default as UnlockOutlined } from './UnlockOutlined.svg?react';
export { default as UploadOutlined } from './UploadOutlined.svg?react';
export { default as UserDeleteOutlined } from './UserDeleteOutlined.svg?react';
export { default as UserOutlined } from './UserOutlined.svg?react';
export { default as WalletOutlined } from './WalletOutlined.svg?react';
